module.exports = __webpack_public_path__ + "static/media/sinjal.94b8666b.jpg";